/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import ForgotPasswordSectionDumb from './ForgotPasswordSectionDumb';
import { resetPasswordLinkSent } from 'src/shared/app/authentication/action/base/authenticationActions';
import { isPasswordLinkSent } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import withMount from 'src/shared/app/base/component/hoc/withMount';

type Props = {
  handleHelpClick: () => void,
  handleBack: () => void,
};

const mapStateToProps = (state: Object, ownProps: Props): Object => {
  const { handleHelpClick, handleBack } = ownProps;

  return {
    isLinkSent: isPasswordLinkSent(state),
    handleHelpClick,
    handleBack,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleMount() {
    dispatch(resetPasswordLinkSent());
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(ForgotPasswordSectionDumb);
